<template>
  <div class="row mt-1">
    <div class="col-md-6">
      <a-skeleton active v-if="loading" />
      <a-form :form="form" v-else>
        <a-tabs default-active-key="1">
          <!-- En-tête Tab -->
          <a-tab-pane
            key="1"
            :tab="$t('bulletinBuilder.enTete')"
            :forceRender="true"
          >
            <a-divider orientation="left">{{
              $t("bulletinBuilder.textuelle")
            }}</a-divider>
            <div class="row">
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.afficherNomEcole')">
                  <div class="d-flex align-items-center">
                    <a-switch
                      v-decorator="[
                        'headers.schoolName',
                        {
                          initialValue: affichageData.headers.schoolName,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showHeaderSetting('schoolName')"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item
                  :label="$t('bulletinBuilder.afficherAnneeScolaire')"
                >
                  <div class="d-flex align-items-center">
                    <a-switch
                      v-decorator="[
                        'headers.schoolarYear',
                        {
                          initialValue: affichageData.headers.schoolarYear,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showHeaderSetting('schoolarYear')"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.afficherNomClasse')">
                  <div class="d-flex align-items-center">
                    <a-switch
                      v-decorator="[
                        'headers.className',
                        {
                          initialValue: affichageData.headers.className,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showHeaderSetting('className')"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item
                  :label="$t('bulletinBuilder.afficherTextMinistere')"
                >
                  <a-switch
                    v-decorator="[
                      'headers.govText',
                      {
                        initialValue: affichageData.headers.govText,
                        valuePropName: 'checked',
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.afficherNomEleve')">
                  <div class="d-flex align-items-center">
                    <a-switch
                      v-decorator="[
                        'headers.studentName',
                        {
                          initialValue: affichageData.headers.studentName,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showHeaderSetting('studentName')"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item
                  :label="$t('bulletinBuilder.afficherDateNaissance')"
                >
                  <div class="d-flex align-items-center">
                    <a-switch
                      v-decorator="[
                        'headers.birthDate',
                        {
                          initialValue: affichageData.headers.birthDate,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showHeaderSetting('birthDate')"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item
                  :label="$t('bulletinBuilder.afficherNbInscription')"
                >
                  <div class="d-flex align-items-center">
                    <a-switch
                      v-decorator="[
                        'headers.nbInscription',
                        {
                          initialValue: affichageData.headers.nbInscription,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showHeaderSetting('nbInscription')"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item
                  :label="$t('bulletinBuilder.afficherIdentifiantUnique')"
                >
                  <div class="d-flex align-items-center">
                    <a-switch
                      v-decorator="[
                        'headers.uniqueIden',
                        {
                          initialValue: affichageData.headers.uniqueIden,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showHeaderSetting('uniqueIden')"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.enteteTrimestre')">
                  <div class="d-flex align-items-center">
                    <a-input
                      v-decorator="[
                        'headers.trimHeader',
                        {
                          initialValue: affichageData.headers.trimHeader,
                        },
                      ]"
                    />
                  </div>
                </a-form-item>
              </div>
              <a-divider orientation="left">{{
                $t("bulletinBuilder.images")
              }}</a-divider>

              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.afficherLogoEcole')">
                  <div class="d-flex align-items-center">
                    <a-switch
                      v-decorator="[
                        'headers.schoolLogo',
                        {
                          initialValue: affichageData.headers.schoolLogo,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showLogoSetting('schoolLogo')"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.afficherImageEleve')">
                  <div class="d-flex align-items-center">
                    <a-switch
                      v-decorator="[
                        'headers.studentImage',
                        {
                          initialValue: affichageData.headers.studentImage,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showLogoSetting('studentImage')"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item
                  :label="$t('bulletinBuilder.afficherLogoMinistere')"
                >
                  <div class="d-flex align-items-center">
                    <a-switch
                      v-decorator="[
                        'headers.govLogo',
                        {
                          initialValue: affichageData.headers.govLogo,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showLogoSetting('govLogo')"
                    />
                  </div>
                </a-form-item>
              </div>
            </div>
          </a-tab-pane>
          <!-- Corps Tab -->
          <a-tab-pane
            key="2"
            :tab="$t('bulletinBuilder.corps')"
            :forceRender="true"
          >
            <a-divider orientation="left">{{
              $t("bulletinBuilder.couleurs")
            }}</a-divider>
            <div class="row">
              <div class="col-md-12">
                <a-form-item>
                  <a-button
                    type="primary"
                    icon="highlight"
                    class="color-palette-btn"
                    @click="showColorPalette"
                  >
                    <span class="btn-text">{{
                      $t("bulletinBuilder.personnaliserCouleurs")
                    }}</span>
                    <a-icon type="right" class="ml-2" />
                  </a-button>
                  <div class="color-preview mt-2">
                    <span>{{ $t("bulletinBuilder.paletteCouleurs") }}</span>
                    <div
                      class="color-box"
                      v-for="(color, key) in affichageData.colorPalette"
                      :key="key"
                    >
                      <div
                        class="color-swatch"
                        :style="{ backgroundColor: color }"
                      ></div>
                    </div>
                  </div>
                </a-form-item>
              </div>
            </div>
            <a-divider orientation="left">{{
              $t("bulletinBuilder.taillesPolice")
            }}</a-divider>
            <div class="row">
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.noteSousMatiere')">
                  <div class="d-flex align-items-center">
                    <a-switch
                      :checkedChildren="$t('all.automatique')"
                      :unCheckedChildren="$t('all.manuel')"
                      v-decorator="[
                        'body.subsubjectMark.auto',
                        {
                          initialValue:
                            affichageData.body.subsubjectMark &&
                            affichageData.body.subsubjectMark.auto,
                          valuePropName: 'checked',
                        },
                      ]"
                    >
                    </a-switch>
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showBodyFontSetting('subsubjectMark')"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.noteMatiere')">
                  <div class="d-flex align-items-center">
                    <a-switch
                      :checkedChildren="$t('all.automatique')"
                      :unCheckedChildren="$t('all.manuel')"
                      v-decorator="[
                        'body.subjectMark.auto',
                        {
                          initialValue:
                            affichageData.body.subjectMark &&
                            affichageData.body.subjectMark.auto,
                          valuePropName: 'checked',
                        },
                      ]"
                    >
                    </a-switch>
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showBodyFontSetting('subjectMark')"
                    />
                  </div>
                </a-form-item>
              </div>

              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.noteModule')">
                  <div class="d-flex align-items-center">
                    <a-switch
                      :checkedChildren="$t('all.automatique')"
                      :unCheckedChildren="$t('all.manuel')"
                      v-decorator="[
                        'body.moduleMark.auto',
                        {
                          initialValue:
                            affichageData.body.moduleMark &&
                            affichageData.body.moduleMark.auto,
                          valuePropName: 'checked',
                        },
                      ]"
                    >
                    </a-switch>
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showBodyFontSetting('moduleMark')"
                    />
                  </div>
                </a-form-item>
              </div>

              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.appreciation')">
                  <div class="d-flex align-items-center">
                    <a-switch
                      :checkedChildren="$t('all.automatique')"
                      :unCheckedChildren="$t('all.manuel')"
                      v-decorator="[
                        'body.appreciation.auto',
                        {
                          initialValue:
                            affichageData.body.appreciation &&
                            affichageData.body.appreciation.auto,
                          valuePropName: 'checked',
                        },
                      ]"
                    >
                    </a-switch>
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showBodyFontSetting('appreciation')"
                    />
                  </div>
                </a-form-item>
              </div>

              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.minParClasse')">
                  <div class="d-flex align-items-center">
                    <a-switch
                      :checkedChildren="$t('all.automatique')"
                      :unCheckedChildren="$t('all.manuel')"
                      v-decorator="[
                        'body.minPerClass.auto',
                        {
                          initialValue:
                            affichageData.body.minPerClass &&
                            affichageData.body.minPerClass.auto,
                          valuePropName: 'checked',
                        },
                      ]"
                    >
                    </a-switch>
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showBodyFontSetting('minPerClass')"
                    />
                  </div>
                </a-form-item>
              </div>

              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.maxParClasse')">
                  <div class="d-flex align-items-center">
                    <a-switch
                      :checkedChildren="$t('all.automatique')"
                      :unCheckedChildren="$t('all.manuel')"
                      v-decorator="[
                        'body.maxPerClass.auto',
                        {
                          initialValue:
                            affichageData.body.maxPerClass &&
                            affichageData.body.maxPerClass.auto,
                          valuePropName: 'checked',
                        },
                      ]"
                    >
                    </a-switch>
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showBodyFontSetting('maxPerClass')"
                    />
                  </div>
                </a-form-item>
              </div>
            </div>
            <a-divider orientation="left">{{
              $t("bulletinBuilder.optionsAvancees")
            }}</a-divider>
            <a-divider orientation="center">{{
              $t("bulletinBuilder.subjectsOptions")
            }}</a-divider>
            <div class="row">
              <div class="col-md-6">
                <a-form-item
                  :label="$t('bulletinBuilder.fusionnerSousMatieres')"
                >
                  <a-switch
                    v-decorator="[
                      'body.fuseSubjects',
                      {
                        initialValue: affichageData.body.fuseSubjects,
                        valuePropName: 'checked',
                      },
                    ]"
                  />
                  <a-tooltip placement="rightTop">
                    <template slot="title">
                      <span>{{ $t("bulletinBuilder.contradictoryWith", { option: $t("bulletinBuilder.masquerMatieres") }) }}</span>
                    </template>
                    <a-icon type="info-circle" class="ml-3" color="warning" />
                  </a-tooltip>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.masquerMatieres')">
                  <a-switch
                    v-decorator="[
                      'body.hideSubjects',
                      {
                        initialValue: affichageData.body.hideSubjects,
                        valuePropName: 'checked',
                      },
                    ]"
                  />
                  <a-tooltip placement="rightTop">
                    <template slot="title">
                      <span>{{ $t("bulletinBuilder.contradictoryWith", { option: $t("bulletinBuilder.fusionnerSousMatieres") }) }}</span>
                    </template>
                    <a-icon type="info-circle" class="ml-3" color="warning" />
                  </a-tooltip>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item
                  :label="$t('bulletinBuilder.masquerMinParMatiere')"
                >
                  <a-switch
                    v-decorator="[
                      'body.hideMinPerClass',
                      {
                        initialValue: affichageData.body.hideMinPerClass,
                        valuePropName: 'checked',
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item
                  :label="$t('bulletinBuilder.masquerMaxParMatiere')"
                >
                  <a-switch
                    v-decorator="[
                      'body.hideMaxPerClass',
                      {
                        initialValue: affichageData.body.hideMaxPerClass,
                        valuePropName: 'checked',
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.hideSubjectMark')">
                  <a-switch
                    v-decorator="[
                      'body.hideSubjectMark',
                      {
                        initialValue: affichageData.body.hideSubjectMark,
                        valuePropName: 'checked',
                      },
                    ]"
                  />
                </a-form-item>
              </div>
            </div>
            <a-divider orientation="center">{{
              $t("bulletinBuilder.modulesOptions")
            }}</a-divider>
            <div class="row">
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.showSubmodule')">
                  <a-switch
                    v-decorator="[
                      'body.showSubmodule',
                      {
                        initialValue: affichageData.body.showSubmodule,
                        valuePropName: 'checked',
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.showSubmoduleMoy')">
                  <a-switch
                    v-decorator="[
                      'body.showSubmoduleMoy',
                      {
                        initialValue: affichageData.body.showSubmoduleMoy,
                        valuePropName: 'checked',
                      },
                    ]"
                  />
                  <a-tooltip placement="rightTop">
                    <template slot="title">
                      <span>{{ $t("bulletinBuilder.contradictoryWith", { option: $t("bulletinBuilder.hideModuleMark") }) }}</span>
                    </template>
                    <a-icon type="info-circle" class="ml-3" color="warning" />
                  </a-tooltip>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.hideModuleMark')">
                  <a-switch
                    v-decorator="[
                      'body.hideModuleMark',
                      {
                        initialValue: affichageData.body.hideModuleMark,
                        valuePropName: 'checked',
                      },
                    ]"
                  />
                  <a-tooltip placement="rightTop">
                    <template slot="title">
                      <span>{{ $t("bulletinBuilder.contradictoryWith", { option: $t("bulletinBuilder.showSubmoduleMoy") }) }}</span>
                    </template>
                    <a-icon type="info-circle" class="ml-3" color="warning" />
                  </a-tooltip>
                </a-form-item>
              </div>
            </div>
            <a-divider orientation="center">{{
              $t("bulletinBuilder.otherOptions")
            }}</a-divider>
            <div class="row">
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.pedaLike')">
                  <a-switch
                    v-decorator="[
                      'pedaLike',
                      {
                        initialValue: affichageData.pedaLike,
                        valuePropName: 'checked',
                      },
                    ]"
                  />
                </a-form-item>
              </div>
            </div>
          </a-tab-pane>

          <!-- Coté Tab -->
          <a-tab-pane
            key="3"
            :tab="$t('bulletinBuilder.cote')"
            :forceRender="true"
          >
            <div class="row">
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.afficherMoyenne')">
                  <div class="d-flex align-items-center">
                    <a-switch
                      v-decorator="[
                        'side.normal.allow',
                        {
                          initialValue: affichageData.side.normal.allow,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showMoySetting('normal')"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.afficherMoyennePedagogique')">
                  <div class="d-flex align-items-center">
                    <a-switch
                      v-decorator="[
                        'side.peda.allow',
                        {
                          initialValue: affichageData.side.peda.allow,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showMoySetting('peda')"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.afficherMoyennePersonnalise')">
                  <div class="d-flex align-items-center">
                    <a-switch
                      v-decorator="[
                        'side.personalized.allow',
                        {
                          initialValue: affichageData.side.personalized.allow,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showMoySetting('personalized')"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.certifUsePersonalizedMoy')">
                  <a-switch
                    v-decorator="[
                      'side.certifUsePersonalizedMoy',
                      {
                        initialValue: affichageData.side.certifUsePersonalizedMoy,
                        valuePropName: 'checked',
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item :label="$t('appreciation.adminAppreciation')">
                  <div class="d-flex align-items-center">
                    <a-switch
                      v-decorator="[
                        'side.adminAppreciation',
                        {
                          initialValue: affichageData.side.adminAppreciation,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                    <a-button
                      type="dashed"
                      icon="setting"
                      class="ml-3"
                      shape="circle"
                      @click="showSideFontOption('adminAppreciation')"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.afficherCertif')">
                  <a-switch
                    v-decorator="[
                      'side.certif',
                      {
                        initialValue: affichageData.side.certif,
                        valuePropName: 'checked',
                      },
                    ]"
                  />
                  <a-button
                    type="dashed"
                    icon="setting"
                    class="ml-3"
                    shape="circle"
                    @click="showSideFontOption('certif')"
                  />
                </a-form-item>
              </div>

              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.afficherCache')">
                  <a-switch
                    v-decorator="[
                      'side.stamp',
                      {
                        initialValue: affichageData.side.stamp,
                        valuePropName: 'checked',
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.afficherDate')">
                  <a-switch
                    v-decorator="[
                      'side.printDate',
                      {
                        initialValue: affichageData.side.printDate,
                        valuePropName: 'checked',
                      },
                    ]"
                  />
                </a-form-item>
              </div>
            </div>
          </a-tab-pane>

          <!-- Espacement Tab -->
          <a-tab-pane
            key="4"
            :tab="$t('bulletinBuilder.espacement')"
            :forceRender="true"
          >
            <a-alert
              :message="$t('bulletinBuilder.sensitiveOption')"
              type="info"
              show-icon
              :close-text="$t('all.understood')"
            />
            <div class="row">
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.forcerUnePage')">
                  <a-switch
                    v-decorator="[
                      'spacing.forceOnePage',
                      {
                        initialValue: affichageData.spacing.forceOnePage,
                        valuePropName: 'checked',
                      },
                    ]"
                  />
                  <a-tooltip placement="rightTop">
                    <template slot="title">
                      <span>{{ $t("bulletinBuilder.slowingFactor") }}</span>
                    </template>
                    <a-icon type="info-circle" class="ml-3" color="warning" />
                  </a-tooltip>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.etirerPageEntiere')">
                  <a-switch
                    v-decorator="[
                      'spacing.stretchFullPage',
                      {
                        initialValue: affichageData.spacing.stretchFullPage,
                        valuePropName: 'checked',
                      },
                    ]"
                  />
                  <a-tooltip placement="rightTop">
                    <template slot="title">
                      <span>{{ $t("bulletinBuilder.slowingFactor") }}</span>
                    </template>
                    <a-icon type="info-circle" class="ml-3" color="warning" />
                  </a-tooltip>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item
                  :label="$t('bulletinBuilder.trimersterLineMargin')"
                >
                  <a-input-number
                    :min="0"
                    :max="18"
                    v-decorator="[
                      'spacing.trimersterLineMargin',
                      {
                        initialValue:
                          affichageData.spacing.trimersterLineMargin,
                      },
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item :label="$t('bulletinBuilder.margeInferieure')">
                  <a-input-number
                    :min="0"
                    :max="45"
                    v-decorator="[
                      'spacing.bottomLimit',
                      {
                        initialValue: affichageData.spacing.bottomLimit,
                      },
                    ]"
                  />
                  <a-tooltip placement="rightTop">
                    <template slot="title">
                      <span>{{
                        $t("bulletinBuilder.onlyForForceOnePage")
                      }}</span>
                    </template>
                    <a-icon type="info-circle" class="ml-3" />
                  </a-tooltip>
                </a-form-item>
              </div>
            </div>
          </a-tab-pane>

          <!-- Arrière-plan et QR Tab -->
          <a-tab-pane
            key="5"
            :tab="$t('bulletinBuilder.images')"
            :forceRender="true"
          >
            <a-divider orientation="left">{{
              $t("bulletinBuilder.additionalImages")
            }}</a-divider>
            <div class="row mb-5">
              <div class="col-md-4">
                <a-form-item :label="$t('bulletinBuilder.ajouterQRCode')">
                  <a-switch
                    :defaultChecked="affichageData.qrCode ? true : false"
                    v-model="qrCodeChecker"
                  />
                </a-form-item>
              </div>
              <div class="col-md-8 mb-4">
                <a-upload-dragger
                  name="qrCode"
                  :file-list="qrCode"
                  :before-upload="(data) => beforeUploadFiles('qr', data)"
                  :remove="() => handleRemove('qr')"
                  :custom-request="() => true"
                >
                  <p class="ant-upload-drag-icon">
                    <a-icon type="inbox" />
                  </p>
                  <p class="ant-upload-text">
                    {{ $t("bulletinBuilder.cliquezGlisser") }}
                  </p>
                  <p class="ant-upload-hint">
                    {{ $t("bulletinBuilder.supportImageUnique") }}
                  </p>
                </a-upload-dragger>
                <a-progress
                  :stroke-color="{
                    from: '#108ee9',
                    to: '#87d068',
                  }"
                  v-if="qrCodeProgress.value > 0"
                  :percent="qrCodeProgress.value"
                  status="active"
                />
              </div>
            </div>
            <div class="row mb-5 mt-4">
              <div class="col-md-4">
                <a-form-item :label="$t('bulletinBuilder.ajouterArrierePlan')">
                  <a-switch
                    :defaultChecked="affichageData.bg_image ? true : false"
                    v-model="bgImageChecker"
                  />
                </a-form-item>
              </div>
              <div class="col-md-8 mb-4">
                <a-upload-dragger
                  name="bg_image"
                  :file-list="bgImage"
                  :before-upload="(data) => beforeUploadFiles('bg', data)"
                  :remove="() => handleRemove('bg')"
                  :custom-request="() => true"
                >
                  <p class="ant-upload-drag-icon">
                    <a-icon type="inbox" />
                  </p>
                  <p class="ant-upload-text">
                    {{ $t("bulletinBuilder.cliquezGlisser") }}
                  </p>
                  <p class="ant-upload-hint">
                    {{ $t("bulletinBuilder.supportImageUnique") }}
                  </p>
                </a-upload-dragger>
                <a-progress
                  :stroke-color="{
                    from: '#108ee9',
                    to: '#87d068',
                  }"
                  v-if="bgImageProgress.value > 0"
                  :percent="bgImageProgress.value"
                  status="active"
                  class="mb-2"
                />
              </div>
            </div>
            <div class="row mb-5 mt-4">
              <div class="col-md-4">
                <a-form-item :label="$t('bulletinBuilder.customGovLogo')">
                  <a-switch
                    :defaultChecked="affichageData.headers.customGovLogo ? true : false"
                    v-model="govImageChecker"
                  />
                </a-form-item>
              </div>
              <div class="col-md-8 mb-4">
                <a-upload-dragger
                  name="govImage"
                  :file-list="govImage"
                  :before-upload="(data) => beforeUploadFiles('gov', data)"
                  :remove="() => handleRemove('gov')"
                  :custom-request="() => true"
                >
                  <p class="ant-upload-drag-icon">
                    <a-icon type="inbox" />
                  </p>
                  <p class="ant-upload-text">
                    {{ $t("bulletinBuilder.cliquezGlisser") }}
                  </p>
                  <p class="ant-upload-hint">
                    {{ $t("bulletinBuilder.supportImageUnique") }}
                  </p>
                </a-upload-dragger>
                <a-progress
                  :stroke-color="{
                    from: '#108ee9',
                    to: '#87d068',
                  }"
                  v-if="govImageProgress.value > 0"
                  :percent="govImageProgress.value"
                  status="active"
                  class="mb-2"
                />
              </div>
            </div>
            <a-divider orientation="left">{{
              $t("bulletinBuilder.scaleImages")
            }}</a-divider>
              <a-alert class="mb-4"
                :message="$t('bulletinBuilder.scaleImagesTooltip')"
                type="info"
                show-icon
                :close-text="$t('all.understood')"
              />
              <a-row :gutter="[8, 32]">
                <a-col :span="12">
                  <a-form-item :label="$t('bulletinBuilder.schoolLogo')">
                    <a-input-number
                      :min="0.1"
                      :max="3"
                      :step="0.1"
                      v-decorator="['options.imageScalers.schoolLogo', { initialValue: affichageData.options.imageScalers.schoolLogo }]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('bulletinBuilder.studentImage')">
                    <a-input-number
                      :min="0.1"
                      :max="3"
                      :step="0.1"
                      v-decorator="['options.imageScalers.studentImage', { initialValue: affichageData.options.imageScalers.studentImage }]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('bulletinBuilder.govLogo')">
                    <a-input-number
                      :min="0.1"
                      :max="3"
                      :step="0.1"
                      v-decorator="['options.imageScalers.govLogo', { initialValue: affichageData.options.imageScalers.govLogo }]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('certification.stamp')">
                    <a-input-number
                      :min="0.1"
                      :max="3"
                      :step="0.1"
                      v-decorator="['options.imageScalers.stamp', { initialValue: affichageData.options.imageScalers.stamp }]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('profil.qrCode')">
                    <a-input-number
                      :min="0.1"
                      :max="3"
                      :step="0.1"
                      v-decorator="['options.imageScalers.qrCode', { initialValue: affichageData.options.imageScalers.qrCode }]"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
          </a-tab-pane>
        </a-tabs>
      </a-form>
    </div>

    <!-- Preview Section -->
    <div class="col-md-6 mt-4">
      <div class="preview-container">
        <div class="preview-header">
          <h3 class="preview-title">
            {{ $t("bulletinBuilder.apercuBulletin") }}
          </h3>
          <div class="preview-controls">
            <a-select
              :placeholder="$t('bulletinBuilder.selectionnerEleve')"
              class="preview-select"
              allow-clear
              @change="selectStudent"
              v-model="studentID"
            >
              <a-select-opt-group
                v-for="classroom in Object.values(students)"
                :key="classroom.classRoomID"
              >
                <span slot="label">{{ classroom.classRoom }}</span>
                <a-select-option
                  v-for="student in classroom.students"
                  :key="student._id"
                  :value="student._id"
                >
                  {{ student.firstName }} {{ student.middleName }} {{ student.lastName }}
                </a-select-option>
              </a-select-opt-group>
            </a-select>
            <div class="preview-actions">
              <a-select
                :placeholder="$t('bulletinBuilder.selectionnerTemplate')"
                class="preview-select"
                allow-clear
                :defaultValue="affichageData.usedTemplate || undefined"
                @change="selectTemplate"
              >
                <a-select-option
                  v-for="template in templateList"
                  :key="template.templateKey"
                  :value="template.templateKey"
                >
                  {{ template.templateName }}
                </a-select-option>
              </a-select>
              <div class="preview-buttons">
                <a-button
                  type="primary"
                  icon="reload"
                  class="preview-btn"
                  @click="renderPDF"
                >
                  {{ $t("bulletinBuilder.actualiser") }}
                </a-button>
              </div>
            </div>
          </div>
        </div>
        <div class="preview-content">
          <iframe
            v-if="pdfVisible"
            class="preview-iframe"
            :src="pdfBlobUrl"
            style="width: 100%; height: calc(100vw * 1.4142); max-height: 95vh"
          />
          <div v-else class="preview-placeholder">
            <a-spin v-if="pdfLoading" size="large" />
            <div v-else class="preview-empty">
              <a-icon type="file-pdf" class="preview-icon" />
              <p class="preview-text">
                {{ $t("bulletinBuilder.selectionnerEleveDabord") }}
              </p>
              <a-button type="primary" @click="renderPDF">
                <a-icon type="eye" />
                {{ $t("bulletinBuilder.visualiserBulletin") }}
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="col-md-2 offset-md-6 mt-3">
      <a-popconfirm
        v-if="!isReadOnly && !isSubmitting"
        :title="$t('all.sureToCancelAlert')"
        :ok-text="$t('all.oui')"
        :cancel-text="$t('all.non')"
        @confirm="undo"
      >
        <a-button type="danger" class="w-100">
          <a-icon type="undo" />
          {{ $t("all.cancel") }}
        </a-button>
      </a-popconfirm>
      <a-button v-else type="danger" class="w-100" :disabled="true">
        <a-icon type="undo" />
        {{ $t("all.cancel") }}
      </a-button>
    </div>
    <div class="col-md-4 mt-3">
      <a-button
        type="primary"
        class="w-100"
        @click="saveConfig"
        :disabled="isSubmitting || isReadOnly"
      >
        <a-icon type="save" />
        {{ $t("all.save") }}
      </a-button>
    </div>

    <!-- Modals -->
    <a-modal
      :visible="headerSettingModel"
      centered
      @cancel="handleCancel"
      width="50%"
      :title="modalTitle"
      :footer="false"
    >
      <a-form
        :form="headerSettingForm"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-divider>{{ $t("bulletinBuilder.titre") }}</a-divider>
        <a-row :gutter="[8, 32]">
          <a-col :span="12">
            <a-form-item :label="$t('bulletinBuilder.font') + ' :'">
              <a-select
                :placeholder="$t('bulletinBuilder.selectFont')"
                style="width: 100%"
                v-decorator="[
                  'title.font',
                  {
                    initialValue: activeHeaderTexTConfig.title.font,
                  },
                ]"
              >
                <template>
                  <a-select-opt-group
                    v-for="(group, index) in fontGroups"
                    :label="group.label"
                    :key="index"
                  >
                    <a-select-option
                      v-for="font in group.options"
                      :key="font.value"
                      :value="font.value"
                    >
                      {{ font.label }}
                    </a-select-option>
                  </a-select-opt-group>
                </template>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="$t('bulletinBuilder.taille') + ' :'">
              <a-input-number
                :min="6"
                :max="18"
                v-decorator="[
                  'title.size',
                  {
                    initialValue: activeHeaderTexTConfig.title.size,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="$t('bulletinBuilder.couleur') + ' :'">
              <a-input
                type="color"
                v-decorator="[
                  'title.color',
                  {
                    initialValue: activeHeaderTexTConfig.title.color,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-divider>{{ $t("bulletinBuilder.valeur") }}</a-divider>
        <a-row :gutter="[8, 32]">
          <a-col :span="12">
            <a-form-item :label="$t('bulletinBuilder.font') + ' :'">
              <a-select
                :placeholder="$t('bulletinBuilder.selectFont')"
                style="width: 100%"
                v-decorator="[
                  'value.font',
                  {
                    initialValue: activeHeaderTexTConfig.value.font,
                  },
                ]"
              >
                <template>
                  <a-select-opt-group
                    v-for="(group, index) in fontGroups"
                    :label="group.label"
                    :key="index"
                  >
                    <a-select-option
                      v-for="font in group.options"
                      :key="font.value"
                      :value="font.value"
                    >
                      {{ font.label }}
                    </a-select-option>
                  </a-select-opt-group>
                </template>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="$t('bulletinBuilder.taille') + ' :'">
              <a-input-number
                :min="6"
                :max="18"
                v-decorator="[
                  'value.size',
                  {
                    initialValue: activeHeaderTexTConfig.value.size,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="$t('bulletinBuilder.couleur') + ' :'">
              <a-input
                type="color"
                v-decorator="[
                  'value.color',
                  {
                    initialValue: activeHeaderTexTConfig.value.color,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="[8, 32]">
          <a-col :span="12" :offset="2">
            <a-form-item :label="$t('bulletinBuilder.lineReturn') + ' :'">
              <a-checkbox
                v-decorator="[
                  'lineReturn',
                  {
                    initialValue: affichageData.lineReturn,
                    valuePropName: 'checked',
                  },
                ]"
              />
              <a-tooltip placement="rightTop">
                <template slot="title">
                  <span>{{
                    $t("bulletinBuilder.nonDisponiblePourEnTeteBas")
                  }}</span>
                </template>
                <a-icon type="info-circle" class="ml-3" />
              </a-tooltip>
            </a-form-item>
          </a-col>
        </a-row>
        <a-divider>{{ $t("bulletinBuilder.position") }}</a-divider>
        <a-row :gutter="[8, 32]">
          <a-col :span="12">
            <a-form-item :label="$t('bulletinBuilder.position') + ' :'">
              <a-select
                :placeholder="$t('bulletinBuilder.positionX')"
                style="width: 100%"
                v-decorator="[
                  'pos[0]',
                  {
                    initialValue: activeHeaderTexTConfig.pos[0],
                  },
                ]"
              >
                <a-select-option value="c">{{
                  $t("bulletinBuilder.centre")
                }}</a-select-option>
                <a-select-option value="l">{{
                  $t("bulletinBuilder.gauche")
                }}</a-select-option>
                <a-select-option value="r">{{
                  $t("bulletinBuilder.droit")
                }}</a-select-option>
                <a-select-option value="b">{{
                  $t("bulletinBuilder.bas")
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              :label="$t('bulletinBuilder.ordre') + ' :'"
              has-feedback
              :validate-status="headerSettingValidation"
            >
              <a-input-number
                :min="1"
                :max="6"
                v-decorator="[
                  'pos[1]',
                  {
                    initialValue: activeHeaderTexTConfig.pos[1],
                    rules: [
                      {
                        transform: (val) => val - 1,
                        trigger: 'change',
                        validator: createValidationHeaderText,
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col
            :span="4"
            v-if="['warning', 'error'].includes(headerSettingValidation)"
          >
            <a-tag color="geekblue">
              {{ $t("bulletinBuilder.changerPositions") }}
              <a-icon
                type="undo"
                style="margin-left: 8px; cursor: pointer"
                @click="exchangesHeaderText"
              />
            </a-tag>
          </a-col>
        </a-row>
      </a-form>
      <a-row :gutter="[8, 32]">
        <a-col :span="12" :offset="12">
          <a-button type="primary" class="w-100" @click="saveHeaderSetting">
            <a-icon type="save" />{{ $t("all.apply") }}
          </a-button>
        </a-col>
      </a-row>
    </a-modal>
    <a-modal
      :visible="headerLogoModel"
      centered
      @cancel="handleCancel"
      width="40%"
      :title="modalTitle"
      :footer="false"
    >
      <a-form
        :form="headerLogoForm"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 15 }"
      >
        <a-row :gutter="[8, 32]">
          <a-col :span="12">
            <a-form-item :label="$t('bulletinBuilder.position') + ' :'">
              <a-select
                :placeholder="$t('bulletinBuilder.positionX')"
                style="width: 100%"
                has-feedback
                :validate-status="headerSettingLogoValidation.pos"
                v-decorator="[
                  'pos[0]',
                  {
                    rules: [
                      {
                        transform: (val) => val - 1,
                        trigger: 'change',
                        required: true,
                        validator: createValidationHeaderLogo,
                      },
                    ],
                  },
                ]"
              >
                <a-select-option value="c">{{
                  $t("bulletinBuilder.centre")
                }}</a-select-option>
                <a-select-option value="l">{{
                  $t("bulletinBuilder.gauche")
                }}</a-select-option>
                <a-select-option value="r">{{
                  $t("bulletinBuilder.droit")
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              :label="$t('bulletinBuilder.ordre') + ' :'"
              has-feedback
              :validate-status="headerSettingLogoValidation.order"
            >
              <a-input-number
                :min="1"
                :max="2"
                v-decorator="[
                  'pos[1]',
                  {
                    rules: [
                      {
                        transform: (val) => val - 1,
                        trigger: 'change',
                        required: true,
                        validator: createValidationHeaderLogo,
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col
            :span="4"
            v-if="
              ['warning', 'error'].includes(
                headerSettingLogoValidation.order
              ) ||
              ['warning', 'error'].includes(headerSettingLogoValidation.pos)
            "
          >
            <a-tag color="geekblue">
              {{ $t("bulletinBuilder.changerPositions") }}
              <a-icon
                type="undo"
                style="margin-left: 8px; cursor: pointer"
                @click="exchangesHeaderLogo"
              />
            </a-tag>
          </a-col>
        </a-row>
        <a-row :gutter="[8, 32]">
          <a-col :span="12" :offset="12">
            <a-button type="primary" class="w-100" @click="saveLogoPos">
              <a-icon type="save" />{{ $t("all.apply") }}
            </a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal
      :visible="sideMoyModel"
      centered
      :forceRender="true"
      @cancel="handleCancel"
      width="35%"
      :title="modalTitle"
      :footer="false"
    >
      <a-form
        :form="sideMoyForm"
        @submit="saveSidMoy"
        :label-col="{ span: 32 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-divider orientation="left"
          >{{ $t("bulletinBuilder.optionsAffichage") }}:</a-divider
        >
        <a-row :gutter="[8, 32]">
          <a-col :span="8">
            <a-form-item :label="$t('bulletinBuilder.afficherMinimum') + ' :'">
              <a-switch
                v-decorator="[
                  'min',
                  {
                    initialValue: affichageData.side[selectedMoy].min,
                    valuePropName: 'checked',
                  },
                ]"
              />
              <a-tooltip placement="rightTop">
                <template slot="title">
                  <span>{{ $t("bulletinBuilder.recommandeActiver") }}</span>
                </template>
                <a-icon type="info-circle" class="ml-3" />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('bulletinBuilder.afficherMaximum') + ' :'">
              <a-switch
                v-decorator="[
                  'max',
                  {
                    initialValue: affichageData.side[selectedMoy].max,
                    valuePropName: 'checked',
                  },
                ]"
              />
              <a-tooltip placement="rightTop">
                <template slot="title">
                  <span>{{ $t("bulletinBuilder.recommandeActiver") }}</span>
                </template>
                <a-icon type="info-circle" class="ml-3" />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('bulletinBuilder.afficherRang') + ' :'">
              <a-switch
                v-decorator="[
                  'rank',
                  {
                    initialValue: affichageData.side[selectedMoy].rank,
                    valuePropName: 'checked',
                  },
                ]"
              />
              <a-tooltip placement="rightTop">
                <template slot="title">
                  <span>{{ $t("bulletinBuilder.recommandeActiver") }}</span>
                </template>
                <a-icon type="info-circle" class="ml-3" />
              </a-tooltip>
            </a-form-item>
          </a-col>
        </a-row>
        <a-divider orientation="left"
          >{{ $t("bulletinBuilder.couleurs") }}:</a-divider
        >
        <a-row :gutter="[8, 24]">
          <a-col :span="12">
            <a-form-item
              :label="$t('bulletinBuilder.couleurMoyenne')"
              :label-col="{ span: 16 }"
              :wrapper-col="{ span: 18 }"
            >
              <a-input type="color" v-decorator="['colors.moy']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('bulletinBuilder.couleurRang')"
              :label-col="{ span: 12 }"
              :wrapper-col="{ span: 18 }"
            >
              <a-input type="color" v-decorator="['colors.rank']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item
              :label="$t('bulletinBuilder.couleurMin')"
              :label-col="{ span: 12 }"
              :wrapper-col="{ span: 18 }"
            >
              <a-input type="color" v-decorator="['colors.min']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('bulletinBuilder.couleurMax')"
              :label-col="{ span: 12 }"
              :wrapper-col="{ span: 18 }"
            >
              <a-input type="color" v-decorator="['colors.max']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-divider orientation="left">{{
          $t("bulletinBuilder.legende")
        }}</a-divider>
        <a-row :gutter="[8, 32]">
          <a-col :span="24">
            <a-form-item
              :label="$t('bulletinBuilder.libelle') + ' :'"
              :labelCol="{ span: 32 }"
              :wrapperCol="{ span: 32 }"
            >
              <a-input
                v-decorator="[
                  'name',
                  {
                    initialValue: affichageData.side[selectedMoy].name,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col v-if="selectedMoy == 'personalized'" :span="12">
            <a-form-item
              :label="$t('bulletinBuilder.coefficientMoyenne') + ':'"
              :labelCol="{ span: 12 }"
              :wrapperCol="{ span: 32 }"
            >
              <a-input-number
                :min="0"
                v-decorator="[
                  'coefMoy',
                  {
                    initialValue: affichageData.side[selectedMoy].coefMoy,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col v-if="selectedMoy == 'personalized'" :span="12">
            <a-form-item
              :label="$t('bulletinBuilder.coefficientMoyennePedagogique') + ':'"
              :labelCol="{ span: 12 }"
              :wrapperCol="{ span: 32 }"
            >
              <a-input-number
                :min="0"
                v-decorator="[
                  'coefPeda',
                  {
                    initialValue: affichageData.side[selectedMoy].coefPeda,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="[8, 32]">
          <a-col :span="12">
            <a-button type="secondary" class="w-100" @click="handleCancel">
              <a-icon type="undo" />{{ $t("all.cancel") }}
            </a-button>
          </a-col>
          <a-col :span="12">
            <a-button type="primary" class="w-100" htmlType="submit">
              <a-icon type="save" />{{ $t("all.apply") }}
            </a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal
      :visible="colorPaletteModal"
      centered
      :forceRender="true"
      @cancel="handleCancel"
      width="55%"
      :title="$t('bulletinBuilder.modifierCouleurs')"
      :footer="false"
    >
      <a-form
        :form="colorPaletteForm"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
        @submit="saveColorPalette"
      >
        <a-row :gutter="[8, 24]">
          <a-col :span="12">
            <a-form-item
              :label="$t('bulletinBuilder.couleurPrincipale')"
              :extra="$t('bulletinBuilder.enteteTrimestreTitres')"
            >
              <a-input type="color" v-decorator="['main']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('bulletinBuilder.bordureCouleurPrincipale')"
            >
              <a-input type="color" v-decorator="['mainBorder']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="[8, 24]">
          <a-col :span="12">
            <a-form-item
              :label="$t('bulletinBuilder.couleurSecondaire')"
              :extra="$t('bulletinBuilder.titresMoyennes')"
            >
              <a-input type="color" v-decorator="['secondary']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('bulletinBuilder.bordureCouleurSecondaire')"
            >
              <a-input type="color" v-decorator="['secondaryBorder']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="[8, 24]">
          <a-col :span="12">
            <a-form-item
              :label="$t('bulletinBuilder.couleurTertiaire')"
              :extra="$t('bulletinBuilder.arrierePlanMinMaxRang')"
            >
              <a-input type="color" v-decorator="['tertiary']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('bulletinBuilder.bordureCouleurTertiaire')">
              <a-input type="color" v-decorator="['tertiaryBorder']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="[8, 32]">
          <a-col :span="12" :offset="12">
            <a-button type="primary" class="w-100" htmlType="submit">
              <a-icon type="save" />{{ $t("all.apply") }}
            </a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal
      :visible="bodyFontSettingModel"
      centered
      @cancel="handleCancel"
      width="30%"
      :title="modalTitle"
      :footer="false"
    >
      <a-form
        :form="bodyFontSettingForm"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-row :gutter="[8, 32]">
          <a-col :span="12">
            <a-form-item :label="$t('bulletinBuilder.taille') + ' :'">
              <a-input-number
                :min="6"
                :max="18"
                allow-clear
                v-decorator="[
                  'font',
                  {
                    initialValue: activeBodyFontSetting.font,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('bulletinBuilder.couleur') + ' :'">
              <a-input
                type="color"
                v-decorator="[
                  'color',
                  {
                    initialValue: activeBodyFontSetting.color,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="[8, 32]">
          <a-col :span="12" :offset="12">
            <a-button type="primary" class="w-100" @click="saveBodyFontSetting">
              <a-icon type="save" />{{ $t("all.apply") }}
            </a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal
      :visible="sideFontOptionModel"
      centered
      @cancel="handleCancel"
      @close="handleCancel"
      width="50%"
      :title="modalTitle"
      :footer="false"
    >
      <a-form
        :form="sideFontOptionForm"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-row :gutter="[8, 32]">
          <a-col :span="12">
            <a-form-item :label="$t('bulletinBuilder.font') + ' :'">
              <a-select
                :placeholder="$t('bulletinBuilder.selectFont')"
                style="width: 100%"
                v-decorator="[
                  'font',
                  {
                    initialValue: activeSideFontConfig.font,
                  },
                ]"
              >
                <template>
                  <a-select-opt-group
                    v-for="(group, index) in fontGroups"
                    :label="group.label"
                    :key="index"
                  >
                    <a-select-option
                      v-for="font in group.options"
                      :key="font.value"
                      :value="font.value"
                    >
                      {{ font.label }}
                    </a-select-option>
                  </a-select-opt-group>
                </template>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="$t('bulletinBuilder.taille') + ' :'">
              <a-input-number
                :min="6"
                :max="18"
                v-decorator="[
                  'size',
                  {
                    initialValue: activeSideFontConfig.size,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="$t('bulletinBuilder.couleur') + ' :'">
              <a-input
                type="color"
                v-decorator="[
                  'color',
                  {
                    initialValue: activeSideFontConfig.color,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <a-row :gutter="[8, 32]">
        <a-col :span="12" :offset="12">
          <a-button type="primary" class="w-100" @click="saveSideFontConfig">
            <a-icon type="save" />{{ $t("all.apply") }}
          </a-button>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import apiClient from "@/services/axios";
import cloneDeep from "lodash/cloneDeep";
const lodash = require("lodash");
import { mapState, mapGetters } from "vuex";
import bulletin from "@/views/bulletinv2/studentMarks/scripts/bulletinHeplers/bulletin";
import "./bulletinBuilder.css";
import { uploadFilesToS3 } from "@/services/uploadService";

const Bulletin = bulletin.Bulletin;
const btHelpers = {
  printBulletin: bulletin.printBulletin,
  printAllBulletin: bulletin.printAllBulletin,
};
const getFont = (fontValue, tojspd = false) => {
  if (tojspd) {
    if (typeof fontValue == "string" && fontValue.includes("-")) {
      const splitArray = fontValue.split("-");
      return [splitArray[0], splitArray[splitArray.length - 1]];
    } else return [fontValue || "Amiri", "normal"];
  } else {
    return fontValue?.font && fontValue?.style
      ? `${fontValue.font}-${fontValue.style}`
      : "Amiri-normal";
  }
};
export default {
  name: "SysGestLMSSpec",
  props: {
    affichageData: {
      type: Object,
      required: true,
    },
    studentData: {},
    loading: {
      type: Boolean,
      required: true,
      default: true,
    },
    templateList: {
      type: Array,
    },
    certifParams: {
      type: Array,
    },
    students: {
      type: Object,
    },
    studentsKey: {
      type: Number,
    },
  },
  computed: {
    ...mapState(["settings", "user"]),
    ...mapGetters("settings", ["packDetailsGetter"]),
    isReadOnly() {
      const value = this.packDetailsGetter?.access?.edManager?.displaySettings
      return value === "ro";
    },
  },
  watch: {
    affichageData: {
      handler: function (newVal, oldVal) {
        const newValFormData = {
          headers: newVal.headers,
          body: newVal.body,
          spacing: newVal.spacing,
          pedaLike: newVal.pedaLike,
          side: {
            printDate: newVal.side.printDate,
            stamp: newVal.side.stamp,
            adminAppreciation: newVal.side.adminAppreciation,
            certif: newVal.side.certif,
          },
        };
        const oldValFormData = {
          headers: oldVal.headers,
          body: oldVal.body,
          spacing: oldVal.spacing,
          pedaLike: oldVal.pedaLike,
          side: {
            printDate: oldVal.side.printDate,
            stamp: oldVal.side.stamp,
            adminAppreciation: oldVal.side.adminAppreciation,
            certif: oldVal.side.certif,
          },
        };
        if (!lodash.isEqual(newValFormData, oldValFormData))
          this.form.setFieldsValue(newVal);
        this.bgImageChecker = Boolean(
          typeof newVal.bg_image == "string" && newVal.bg_image.length > 0
        );
        this.qrCodeChecker = Boolean(
          typeof newVal.qrCode == "string" && newVal.qrCode.length > 0
        );
        this.govImageChecker = Boolean(
          typeof newVal.headers.customGovLogo == "string" && newVal.headers.customGovLogo.length > 0
        );
      },
      deep: true,
    },
    studentsKey: {
      handler: function (_, __) {
        this.selectedStudent = {};
        this.bulletinData = null;
        this.studentID = undefined;
        this.pdfVisible = false;
        this.pdfLoading = false;
      },
    },
  },
  data() {
    return {
      qrCode: [],
      bgImage: [],
      govImage:[],
      govImageChecker:false,
      qrCodeChecker: false,
      bgImageChecker: false,
      form: this.$form.createForm(this),
      headerSettingForm: this.$form.createForm(this),
      headerLogoForm: this.$form.createForm(this),
      sideMoyForm: this.$form.createForm(this),
      colorPaletteForm: this.$form.createForm(this),
      bodyFontSettingForm: this.$form.createForm(this),
      sideFontOptionForm: this.$form.createForm(this),
      sideFontOptionModel: false,
      activeSideFontConfig: {
        font: "Amiri-normal",
        color: "#433e3f",
        size: 10,
      },
      selectSideFont: "certif",
      pdfBlobUrl: "",
      selectedHeader: "",
      selectedBodyElement: "",
      headerSettingValidation: "",
      headerSettingLogoValidation: {
        pos: "",
        order: "",
      },
      colorsExtras: [
        "Bordure de : titre du module, max par classe, ...",
        "Arrière-plan de : titre du module, text du max par classe, ...",
        "",
        "Moyenne, max, min et rang",
        "Arrière-plan de titre de: Moyenne, max, min et rang, ...",
        "Arrière-plan de titre de: Moyenne, max, min et rang, appreciation, ...",
        "Arrière-plan de nom de matière",
        "Arrière-plan de: max, min et rang",
        "Arrière-plan de nom de sous-matière",
      ],
      selectedStudent: {},
      bulletinData: null,
      selectedMoy: "normal",
      modalTitle: "",
      headerSettingModel: false,
      headerLogoModel: false,
      sideMoyModel: false,
      colorPaletteModal: false,
      bodyFontSettingModel: false,
      pdfLoading: false,
      pdfVisible: false,
      fontGroups: [],
      activeHeaderTexTConfig: {
        title: {
          font: "Amiri-Bold",
          color: "#000000",
          size: 12,
        },
        lineReturn: false,
        value: {
          font: "Amiri-normal",
          color: "#000000",
          size: 12,
        },
        pos: ["r", 0],
      },
      activeBodyFontSetting: {
        auto: true,
        font: 12,
        color: "#000000",
      },
      activeHeaderLogoConfig: ["r", 1],
      studentID: undefined,
      isSubmitting: false,
      bgImageProgress: { value: 0 },
      qrCodeProgress: { value: 0 },
      govImageProgress: { value: 0 },
    };
  },
  methods: {
    handleApiError(error, defaultMessage) {
      // Check for PACK_PERMISSION_ERROR
      if (
        error.response?.data?.errorCode === "PACK_PERMISSION_ERROR" ||
        error.response?.data?.error?.errorCode === "PACK_PERMISSION_ERROR"
      ) {
        this.$message.error(this.$t("errorCode.PACK_PERMISSION_ERROR"));
        return;
      }
      // Fallback to default error message
      this.$message.error(
        error.response?.data?.message || defaultMessage || this.$t("error.erreur")
      );
    },
    exchangesHeaderText() {
      this.headerSettingForm.validateFieldsAndScroll((err, values) => {
        const selectedPosition = values.pos;
        selectedPosition[1] -= 1;
        for (const [header, position] of Object.entries(
          this.affichageData.options.headersPositions
        )) {
          if (
            header != this.selectedHeader &&
            selectedPosition[0] == position[0] &&
            selectedPosition[1] == position[1]
          ) {
            this.affichageData.options.headersPositions[header].pos =
              this.activeHeaderTexTConfig.pos;
            position[1]++;
            this.headerSettingForm.setFieldsValue({ pos: position });
            this.headerSettingForm.validateFields();
            break;
          }
        }
      });
    },
    exchangesHeaderLogo() {
      this.headerLogoForm.validateFieldsAndScroll((err, values) => {
        const selectedPosition = values.pos;
        selectedPosition[1] -= 1;
        for (const [header, position] of Object.entries(
          this.affichageData.options.logosPosition
        )) {
          if (
            header != this.selectedHeader &&
            selectedPosition[0] == position[0] &&
            selectedPosition[1] == position[1]
          ) {
            this.affichageData.options.logosPosition[header].pos =
              this.activeHeaderLogoConfig;
            position[1]++;
            this.headerLogoForm.setFieldsValue({ pos: position });
            this.headerLogoForm.validateFields();
            break;
          }
        }
      });
    },
    async selectStudent(studentID) {
      if (studentID) {
        for (let classRoomStudent of Object.values(this.students)) {
          let studentData = classRoomStudent.students.find(
            (s) => s._id == studentID
          );
          if (studentData) this.selectedStudent = studentData;
          break;
        }

        if (this.selectedStudent._id) {
          await apiClient
            .get(
              `bulletin/v2/bt/${this.affichageData.type}/${studentID}/${this.affichageData.trimester}`
            )
            .then(async ({ data }) => {
              this.bulletinData = data;
              await this.renderPDF();
            })
            .catch((e) => {
              this.$message.error(
                this.$t("bulletinBuilder.errorGettingBulletinData")
              );
            });
        }
      }
    },
    async renderPDF(disableWarning = false) {
      this.pdfLoading = true;
      let config;
      if (this.bulletinData?.id) {
        try {
          config = cloneDeep(this.validFormData());
          if (config.side.stamp) {
            await apiClient
              .get(`/buildings/${this.settings.activeBuildingId}/stamp`)
              .then(({ data }) => {
                config.side.stamp = data?.imageURL ? data.imageURL : null;
              })
              .catch((e) => this.$message.error(this.$t("bulletinBuilder.noStampFound")));
          }
          if (this.bgImageChecker) {
            if (this.bgImage.length > 0) config.bg_image = this.bgImage[0];
          }
          else config.bg_image = null;

          if (this.qrCodeChecker) {
            if (this.qrCode.length > 0) config.qrCode = this.qrCode[0];
          }
          else config.qrCode = null;

          if (this.govImageChecker) {
            if (this.govImage.length > 0) config.headers.customGovLogo = this.govImage[0];
          }
          else config.headers.customGovLogo = null;

          this.pdfBlobUrl = await btHelpers.printBulletin(
            config,
            this.selectedStudent,
            this.bulletinData,
            {
              ...this.settings,
              ...this.user,
              certifs: this.certifParams,
            },
            true
          );
          this.pdfVisible = true;
        } catch (error) {
          console.log(error);
          this.$message.error(
            this.$t("bulletinBuilder.errorPrintingBulletin")
          );
        }
      } else if (!disableWarning)
        this.$message.info(this.$t("bulletinBuilder.selectStudentFirst"));
      this.pdfLoading = false;
    },
    showBodyFontSetting(on) {
      this.selectedBodyElement = on;
      this.activeBodyFontSetting = this.affichageData.body[on] || {
        auto: true,
        font: 12,
        color: "#000000",
      };
      this.bodyFontSettingForm.setFieldsValue(this.activeBodyFontSetting);
      const translateString = this.$t(`bulletinBuilder.${on}`);
      this.modalTitle =
        this.$t("bulletinBuilder.configurer") + " " + translateString;
      this.bodyFontSettingModel = true;
    },
    showHeaderSetting(on) {
      this.selectedHeader = on;
      if (!this.disabledHandler("header", on)) {
        const headerFonts = this.affichageData.options.headerFonts[on];
        const headerPosition = this.affichageData.options.headersPositions[on];
        const defaultHeaderFont = this.affichageData.options.headerFonts["*"];
        if (headerFonts && headerPosition) {
          this.activeHeaderTexTConfig = cloneDeep(headerFonts);
          this.activeHeaderTexTConfig.title.font = getFont(headerFonts.title);
          this.activeHeaderTexTConfig.value.font = getFont(headerFonts.value);
          this.activeHeaderTexTConfig.pos = [
            headerPosition[0],
            headerPosition[1] + 1,
          ];
        } else if (!headerFonts && defaultHeaderFont && headerPosition) {
          this.activeHeaderTexTConfig = cloneDeep(defaultHeaderFont);
          this.activeHeaderTexTConfig.title.font = getFont(
            defaultHeaderFont.title
          );
          this.activeHeaderTexTConfig.value.font = getFont(
            defaultHeaderFont.value
          );
          this.activeHeaderTexTConfig.pos = [
            headerPosition[0],
            headerPosition[1] + 1,
          ];
        }
        const translateString = this.$t(`bulletinBuilder.${on}`);
        this.modalTitle =
          this.$t("bulletinBuilder.configurer") + " " + translateString;
        this.headerSettingModel = true;
        this.headerSettingValidation = "";
        this.headerSettingForm.setFieldsValue(this.activeHeaderTexTConfig);
      } else this.headerSettingModel = false;
    },
    showColorPalette() {
      const colorPalette = cloneDeep(this.affichageData.colorPalette);
      this.colorPaletteForm.setFieldsValue(colorPalette);
      this.colorPaletteModal = true;
    },
    showMoySetting(on) {
      this.selectedMoy = on;
      const values = {
        ...this.affichageData.side[this.selectedMoy],
        colors: {
          ...this.affichageData.colorPalette[this.selectedMoy],
        },
      };
      delete values.allow;
      this.sideMoyForm.setFieldsValue(values);
      this.selectedHeader = on;
      const translateString = this.$t(`bulletinBuilder.${on}`);
      this.modalTitle =
        this.$t("bulletinBuilder.configurer") + " " + translateString;
      this.sideMoyModel = true;
    },
    showSideFontOption(on) {
      this.selectSideFont = on;
      const sideKey = `${on}Font`;
      let sideFont = cloneDeep(this.affichageData.side[sideKey]);
      if (!sideFont) {
        sideFont = {
          font: "Amiri-normal",
          color: "#433e3f",
          size: on == "certif" ? 13 : 10,
        };
      } else {
        sideFont.font = getFont(sideFont);
        sideFont.color = sideFont.color || "#433e3f";
        sideFont.size = sideFont.size
          ? sideFont.size
          : on == "certif"
          ? 13
          : 10;
      }
      this.activeSideFontConfig = sideFont;
      this.sideFontOptionForm.setFieldsValue(sideFont);
      const translateString = this.$t(`bulletinBuilder.${on}`);
      this.modalTitle =
        this.$t("bulletinBuilder.configurer") + " " + translateString;
      this.sideFontOptionModel = true;
    },
    showLogoSetting(on) {
      this.selectedHeader = on;
      const translateString = this.$t(`bulletinBuilder.${on}`);
      this.modalTitle =
        this.$t("bulletinBuilder.configurer") + " " + translateString;
      this.headerLogoModel = true;
      if (this.affichageData.options.logosPosition[on]) {
        const values = [...this.affichageData.options.logosPosition[on]];
        this.headerLogoForm.setFieldsValue({ pos: values });
        this.headerSettingLogoValidation = { pos: "", order: "" };
      }
    },
    handleCancel() {
      this.headerSettingModel = false;
      this.headerLogoModel = false;
      this.sideMoyModel = false;
      this.colorPaletteModal = false;
      this.bodyFontSettingModel = false;
      this.sideFontOptionModel = false;
      this.headerLogoForm.resetFields();
      this.headerSettingForm.resetFields();
    },
    disabledHandler(part, on) {
      if (part == "header") {
      }
      return false;
    },
    async saveSideFontConfig(e) {
      e.preventDefault();
      this.sideFontOptionForm.validateFieldsAndScroll(
        async (err, intiValue) => {
          if (!err) {
            const values = cloneDeep(intiValue);
            const [fontName, fontStyle] = getFont(values.font, true);
            const sideKey = `${this.selectSideFont}Font`;
            this.affichageData.side[sideKey] = {
              font: fontName || "Amiri",
              style: fontStyle || "normal",
              color: values.color || "#433e3f",
              size: values.size
                ? values.size
                : this.selectSideFont == "certif"
                ? 13
                : 10,
            };
            this.$message.success(this.$t("bulletinBuilder.parametresEnregistres"));
            this.sideFontOptionModel = false;
            await this.renderPDF(true);
          } else this.$message.warn(this.$t("bulletinBuilder.checkInputs"));
        }
      );
    },
    async saveHeaderSetting(e) {
      e.preventDefault();
      this.headerSettingForm.validateFieldsAndScroll(async (err, intiValue) => {
        const values = cloneDeep(intiValue);
        if (!err) {
          if (this.affichageData.options.headerFonts["*"]) {
            const title =
              this.affichageData.options.headerFonts["*"].title.color;
            const value =
              this.affichageData.options.headerFonts["*"].value.color;
            if (!Array.isArray(title)) {
              this.affichageData.options.headerFonts["*"].title.color = title;
            }
            if (!Array.isArray(value)) {
              this.affichageData.options.headerFonts["*"].value.color = value;
            }
            this.affichageData.options.headerFonts["*"].title.font = "Amiri";
            this.affichageData.options.headerFonts["*"].value.font = "Amiri";
          }
          const [titleFontName, titleFontStyle] = getFont(
            values.title.font,
            true
          );
          const [valueFontName, valueFontStyle] = getFont(
            values.value.font,
            true
          );
          const titleColor = values.title.color;
          const valueColor = values.value.color;
          values.title.color = titleColor || "#000000";
          values.value.color = valueColor || "#000000";
          values.pos[1] -= 1;
          const position = values.pos;
          this.affichageData.options.headerFonts[this.selectedHeader] = {
            title: {
              font: titleFontName,
              style: titleFontStyle,
              color: values.title.color,
              size: values.title.size,
            },
            lineReturn: values.lineReturn,
            value: {
              font: valueFontName,
              style: valueFontStyle,
              color: values.value.color,
              size: values.value.size,
            },
          };
          this.affichageData.options.headersPositions[this.selectedHeader] =
            position;

          this.$message.success(this.$t("bulletinBuilder.parametresEnregistres"));
          this.headerSettingModel = false;
          await this.renderPDF(true);
        } else this.$message.warn(this.$t("bulletinBuilder.checkInputs"));
      });
    },
    async saveSidMoy(e) {
      e.preventDefault();
      this.sideMoyForm.validateFieldsAndScroll(async (err, values) => {
        const allow = this.affichageData.side[this.selectedMoy].allow;
        const colours = { ...values.colors };
        delete values.colors;
        this.affichageData.side[this.selectedMoy] = { allow, ...values };
        this.affichageData.colorPalette[this.selectedMoy] = colours;
        this.sideMoyModel = false;
        this.$message.success(this.$t("bulletinBuilder.parametresEnregistres"));
        await this.renderPDF(true);
      });
    },
    validFormData() {
      let returns;
      this.form.validateFieldsAndScroll((err, values) => {
        if (err) {
          throw new Error("validation failed");
        } else {
          const imageScalers = values.options.imageScalers || this.affichageData.options.imageScalers;
          values.options = {
            ...this.affichageData.options,
            imageScalers: imageScalers,
          };
          for (let moyKey of ["normal", "peda", "personalized"]) {
            if (values.side[moyKey].allow) {
              values.side[moyKey] = {
                ...this.affichageData.side[moyKey],
                allow: true,
              };
            }
          }
          const reqData = {
            ...this.affichageData,
            ...values,
          };
          reqData.body = {
            ...this.affichageData.body,
            ...values.body,
          };
          reqData.side = {
            ...this.affichageData.side,
            ...values.side,
          };
          reqData.headers = {
            ...this.affichageData.headers,
            ...values.headers,
          };
          for (let key of [
            "subsubjectMark",
            "subjectMark",
            "moduleMark",
            "appreciation",
            "minPerClass",
            "maxPerClass",
          ]) {
            if (!reqData.body[key]?.allow && this.affichageData.body[key])
              reqData.body[key] = {
                ...this.affichageData.body[key],
                auto: reqData.body[key]?.auto,
              };
          }

          if (!reqData.bg_image) reqData.bg_image = null;
          if (!reqData.headers.customGovLogo) reqData.headers.customGovLogo = null;
          if (!reqData.headers.schoolLogo) reqData.headers.schoolLogo = null;
          if (!reqData.headers.studentImage)
            reqData.headers.studentImage = null;
          if (!reqData.headers.govLogo) reqData.headers.govLogo = null;
          if (!reqData.side.stamp) reqData.side.stamp = null;
          if (!reqData.qrCode) reqData.qrCode = null;
          returns = reqData;
        }
      });
      return returns;
    },
    async saveConfig() {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (err) {
          this.$message.error(this.$t("bulletinBuilder.veuillezVerifierChamps"));
        } else {
          this.isSubmitting = true;
          const imageScalers = values.options.imageScalers || this.affichageData.options.imageScalers;
          values.options = {
            ...this.affichageData.options,
            imageScalers: imageScalers,
          };
          for (let moyKey of ["normal", "peda", "personalized"]) {
            if (values.side[moyKey].allow) {
              values.side[moyKey] = {
                ...this.affichageData.side[moyKey],
                allow: true,
              };
            }
          }
          const reqData = {
            ...cloneDeep(this.affichageData),
            ...cloneDeep(values),
          };
          if (typeof this.affichageData.headers.customGovLogo === "string" && this.affichageData.headers.customGovLogo.length > 0) {
            reqData.headers.customGovLogo = this.affichageData.headers.customGovLogo;
          }
          reqData.side = {
            ...cloneDeep(this.affichageData.side),
            ...values.side,
          };
          reqData.body = {
            ...cloneDeep(this.affichageData.body),
            ...values.body,
          };
          for (let key of [
            "subsubjectMark",
            "subjectMark",
            "moduleMark",
            "appreciation",
            "minPerClass",
            "maxPerClass",
          ]) {
            if (!reqData.body[key]?.allow && this.affichageData.body[key])
              reqData.body[key] = {
                ...this.affichageData.body[key],
                auto: reqData.body[key]?.auto,
              };
          }

          this.qrCodeProgress = { value: 0 };
          this.bgImageProgress = { value: 0 };
          this.govImageProgress = { value: 0 };
          // Handle file uploads to S3 first
          try {
            const uploadPromises = [];
            const uploadResults = {};

            // Prepare background image upload if exists
            if (this.bgImageChecker && this.bgImage.length > 0) {
              uploadPromises.push(
                uploadFilesToS3(
                  [this.bgImage[0]],
                  "manager/bulletin/background",
                  this.bgImageProgress
                ).then((keys) => {
                  uploadResults.bgImage = keys[0];
                })
              );
            } else if (!this.bgImageChecker) {
              reqData.bg_image = null;
            }

            // Prepare QR code upload if exists
            if (this.qrCodeChecker && this.qrCode.length > 0) {
              uploadPromises.push(
                uploadFilesToS3(
                  [this.qrCode[0]],
                  "manager/bulletin/qrcode",
                  this.qrCodeProgress
                ).then((keys) => {
                  uploadResults.qrCode = keys[0];
                })
              );
            } else if (!this.qrCodeChecker) {
              reqData.qrCode = null;
            }

            // Prepare custom government logo upload if exists
            if (this.govImageChecker && this.govImage.length > 0) {
              uploadPromises.push(
                uploadFilesToS3(
                  [this.govImage[0]],
                  "manager/bulletin/customGovLogo",
                  this.govImageProgress
                ).then((keys) => {
                  uploadResults.customGovLogo = keys[0];
                })
              );
            } else if (!this.govImageChecker) {
              reqData.headers.customGovLogo = null;
            }

            // Wait for all uploads to complete in parallel
            if (uploadPromises.length > 0) {
              await Promise.all(uploadPromises);

              // Set the uploaded file paths in the request data
              if (uploadResults.bgImage) {
                reqData.bg_image = uploadResults.bgImage;
              }
              if (uploadResults.qrCode) {
                reqData.qrCode = uploadResults.qrCode;
              }
              if (uploadResults.customGovLogo) {
                reqData.headers.customGovLogo = uploadResults.customGovLogo;
              }
            }
          } catch (error) {
            this.$message.error(this.$t("error.impoPubAjout"));
            this.qrCodeProgress = { value: 0 };
            this.bgImageProgress = { value: 0 };
            this.govImageProgress = { value: 0 };
            return;
          }

          if (!reqData.headers.schoolLogo) reqData.headers.schoolLogo = null;
          if (!reqData.headers.studentImage)
            reqData.headers.studentImage = null;
          if (!reqData.headers.govLogo) reqData.headers.govLogo = null;
          if (!reqData.side.stamp) reqData.side.stamp = null;
          if (reqData.options.headerFonts["*"].pos)
            delete reqData.options.headerFonts["*"].pos;
          let reqOK = false;
          if (this.affichageData._id) {
            const id = reqData._id;
            delete reqData._id;
            delete reqData.status;
            delete reqData.__v;
            await apiClient
              .patch("/bulletin/v2/affichage/" + id, reqData)
              .then(({ data }) => {
                reqOK = data;
                delete reqOK.createdAt;
                delete reqOK.updatedAt;
                delete reqOK.__v;
              })
              .catch((e) => {
                this.handleApiError(e, this.$t("bulletinBuilder.parametresNonEnregistres"));
              });
          } else {
            await apiClient
              .put("/bulletin/v2/affichage/", reqData)
              .then(({ data }) => {
                reqOK = data;
              })
              .catch((e) => {
                this.handleApiError(e, this.$t("bulletinBuilder.parametresNonEnregistres"));
              });
          }
          if (reqOK) {
            this.$emit("saveData", reqOK);
            this.form.resetFields();
            this.headerSettingForm.resetFields();
            this.headerLogoForm.resetFields();
            this.colorPaletteForm.resetFields();
            this.sideMoyForm.resetFields();
            this.qrCodeProgress = { value: 0 };
            this.bgImageProgress = { value: 0 };
            this.govImageProgress = { value: 0 };
            this.isSubmitting = false;
            this.$message.success(this.$t("bulletinBuilder.parametresEnregistres"));
          } else {
            this.isSubmitting = false;
          }
        }
      });
    },
    async saveLogoPos(e) {
      e.preventDefault();
      this.headerLogoForm.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const headerImageconfig = cloneDeep(values);
          headerImageconfig.pos[1] = Math.max(headerImageconfig.pos[1] - 1, 0);
          this.affichageData.options.logosPosition[this.selectedHeader] =
            headerImageconfig.pos;
          this.affichageData.headers[this.selectedHeader] = true;
          this.$message.success(this.$t("bulletinBuilder.parametresEnregistres"));
          this.handleCancel();
          await this.renderPDF(true);
        }
      });
    },
    async saveColorPalette(e) {
      e.preventDefault();
      this.colorPaletteForm.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          this.affichageData.colorPalette = {
            ...this.affichageData.colorPalette,
            ...cloneDeep(values),
          };
          this.$message.success(this.$t("bulletinBuilder.parametresEnregistres"));
          this.handleCancel();
          await this.renderPDF(true);
        }
      });
    },
    async saveBodyFontSetting(e) {
      e.preventDefault();
      this.bodyFontSettingForm.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          this.affichageData.body[this.selectedBodyElement] = {
            auto: false,
            ...values,
          };
          this.$message.success(this.$t("bulletinBuilder.parametresEnregistres"));
          this.handleCancel();
          await this.renderPDF(true);
        }
      });
    },
    createValidationHeaderText(rule, value, callback) {
      let validationOk = true;
      const selectedPosition = this.headerSettingForm.getFieldsValue([
        "pos",
      ]).pos;
      selectedPosition[1] -= 1;
      for (const [header, position] of Object.entries(
        this.affichageData.options.headersPositions
      )) {
        if (
          this.affichageData.headers[header] &&
          header != this.selectedHeader &&
          selectedPosition[0] == position[0] &&
          selectedPosition[1] == position[1]
        ) {
          this.headerSettingValidation = "warning";
          validationOk = false;
          callback(this.$t("bulletinBuilder.positionUsedBy") + " " + header);
        }
      }
      if (validationOk) this.headerSettingValidation = "success";
      callback();
    },
    createValidationHeaderLogo(rule, value, callback) {
      let validationOk = true;
      const selectedPosition = this.headerLogoForm.getFieldsValue().pos;
      selectedPosition[1] -= 1;
      for (const [header, position] of Object.entries(
        this.affichageData.options.logosPosition
      )) {
        if (
          header != this.selectedHeader &&
          selectedPosition[0] == position[0] &&
          selectedPosition[1] == position[1] &&
          selectedPosition[0] != null &&
          selectedPosition[1] != null
        ) {
          this.headerSettingLogoValidation = {
            pos: rule.field == "pos[0]" ? "error" : "warning",
            order: rule.field == "pos[1]" ? "error" : "warning",
          };
          validationOk = false;
          callback(this.$t("bulletinBuilder.positionUsedBy") + " " + header);
        }
      }
      if (validationOk && selectedPosition[0] && selectedPosition[1])
        this.headerSettingLogoValidation = {
          pos: "success",
          order: "success",
        };
      callback();
    },
    beforeUploadFiles(on, file) {
      const isValidType =
        file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type === "image/jpg";
      if (!isValidType) {
        this.$message.error(this.$t("error.fichiers"));
      }

      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error(this.$t("error.image"));
      }

      if (isValidType && isLt5M) {
        this.$message.success(
          this.$t("success.imageTelecharge", { name: file.name })
        );

        if (on === "bg") this.bgImage = [file];
        else if(on === "gov") this.govImage = [file];
        else if (on === "qr") this.qrCode = [file];


      }

      return isValidType && isLt5M;
    },
    handleRemove(on) {
      if (on === "bg") this.bgImage = [];
      else if (on === "gov") this.govImage = [];
      else if (on === "qr") this.qrCode = [];
    },
    undo() {
      this.$emit("discard");
      this.form.resetFields();
      this.headerSettingForm.resetFields();
      this.headerLogoForm.resetFields();
      this.colorPaletteForm.resetFields();
      this.sideMoyForm.resetFields();
      this.$message.info(this.$t("bulletinBuilder.restaureParametres"));
    },
    selectTemplate(templateId) {
      this.$emit("selectTemplate", templateId);
      this.form.resetFields();
      this.headerSettingForm.resetFields();
      this.headerLogoForm.resetFields();
      this.colorPaletteForm.resetFields();
      this.sideMoyForm.resetFields();
      this.$message.success(this.$t("bulletinBuilder.modeleSelectionne"));
    },
  },
};
</script>
